import React from 'react';
import './index.scss';

export default function PageTitleContComponent(props) {
  const {
    pageTitleIcon,
    titleText,
    descText,
    pageTitleContStyle = {},
    titleContStyle={},
    titleTextStyle = {}
  } = props;

  return (
    <div className="section-max-container page-title-container" style={pageTitleContStyle}>
      <div className="title-text-cont" style={titleContStyle}>
        {
          titleText &&
          <div className="title-text" style={titleTextStyle}>
            {titleText}
          </div>
        }
        {
          descText &&
          <div className="desc-text">
            {descText}
          </div>
        }
      </div>
      <div className="page-icon-cont">
        {pageTitleIcon}
      </div>
    </div>
  );
}